<template>
    <span class="diff">
        <b :class="[percentageColor]">
            <i :class=" ['fa', percentageArrow]"></i> {{ label }}
        </b>
        <template v-if="showLabel">
            from {{ from | fromNow }}
        </template>
    </span>
</template>
<script>
    import utils from "../utils/units";
    import * as common from "../utils/common";

    import { mapState, mapGetters } from 'vuex';
    export default {
        props: {
            value: {
                type: Number,
                required: true
            },
            from: {
                required: true
            },
            showLabel: {
                required: false,
                default: true
            },
            reversed: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            ...mapState(["currentUser"]),
            ...mapGetters(["isMetric"]),
            //computedValue() {
            //    return this.isMetric ? this.value : utils.toOz(this.value);
            //},
            label() {
                return common.round(this.value * 100, 1) + "%";
            },
            percentageArrow() {
                return this.value == 0 ? 'fa-dot-circle-o' : this.value < 0.0 ? 'fa-caret-down' : 'fa-caret-up'
            },
            percentageColor() {
                if (this.reversed === true) {
                    return this.value == 0 ? 'color-fix' : this.value > 0.0 ? 'color-down' : 'color-up'
                }

                return this.value == 0 ? 'color-fix' : this.value < 0.0 ? 'color-down' : 'color-up'
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/PercentChange.vue